import React from "react";
import styled from "styled-components";

function Error() {

    return (
        <Container>
            <ErrorTitle>Неверная ссылка!</ErrorTitle>
            <ErrorMessage>Попробуйте повторно отправить документы, введя ссылку заново.<br/>
                При возникновении повторных проблем при отправке,
                просим связаться с секретарем Комитета по закупкам по контактам, указанным в закупочной документации.</ErrorMessage>
        </Container>
    );
}

export default Error;

const Container = styled.div`
    width: 900px;
    padding: 40px 50px 40px;
    box-shadow: 0 0 5px 0 rgba(0,0,0,.2);
    box-sizing: border-box;
    margin: 40px auto 20px;
    background: #fff;
    border-radius: 3.01px;
    display: flex;
    flex-direction: column;
    align-items: center; 
    
    @media screen and (max-width: 699px){
        width: 100%;
        border-radius: 0;
        padding: 20px 30px 20px;
    }    
`;

const ErrorTitle = styled.p`
    color: red;
    font-weight: 600;
    font-size: 18px;
`;
const ErrorMessage = styled.p`
    font-weight: 600;
    font-size: 16px;
    text-align: center
`;
